import React, { useState, useEffect } from 'react';
import {
    Typography,
} from '@mui/material';
import styled from 'styled-components';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorConfig } from 'ckeditor5/src/core';

import { FormRichTextEditorInterface } from '../../Models/Common/FormFieldComponentInterfaces';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import CustomFormTitle from './CustomFormTitle';
import CustomTooltip from './CustomTooltip';

const StyledFormRichTextEditorfield = styled.div<{ $isError?: boolean; $darkMode?: boolean; $disabled?: boolean; }>`
    width: 100%;

    .ck.ck-reset.ck-editor.ck-rounded-corners {
        background: ${props => !props?.$disabled ? "transparent" : (props.$darkMode ? '#242728' : '#e9ebec')} !important;
    
        .ck.ck-editor__top.ck-reset_all {
            .ck.ck-sticky-panel {
                .ck.ck-sticky-panel__content {
                    border: none;

                    .ck.ck-toolbar.ck-toolbar_grouping {
                        border: solid 1px;
                        border-color:  ${props => props?.$isError ? "#f44336" : (props.$darkMode ? '#ffffff3b' : '#0000003b')} !important;
                        border-bottom: none;
                        border-radius: 4px 4px 0px 0px;
                        background: transparent;

                        .ck.ck-toolbar__items {
                            .ck.ck-button {
                                color: ${props => props.$darkMode ? '#FFFFFF' : '#000000'} !important;

                                &:hover {
                                    background: ${props => props.$darkMode ? '#2c2d2f' : '#f0f7ff'} !important;
                                }
                            }

                            .ck.ck-button.ck-on {
                                background: ${props => props.$darkMode ? '#2c2d2f' : '#f0f7ff'} !important;
                            }
                        }
                    }
                }
            }
        }

        .ck.ck-editor__main {

            .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,
            .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-focused {
                border: solid 1px;
                border-color:  ${props => props?.$isError ? "#f44336" : (props.$darkMode ? '#ffffff3b' : '#0000003b')} !important;
                border-radius: 0px 0px 4px 4px;
                min-height: 100px;
                box-shadow: none;
                background: transparent;
            }
        }
    }

    .richTextErrorMessage {
        font-size: 0.75rem;
        font-weight: 400;
        color: #f44336;
        margin: 3px 0px 0px 0px;
    }
`;


const FormRichTextField: any = (fieldProps: FormRichTextEditorInterface) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();

    const [editorLoaded, setEditorLoaded] = useState(false);

    const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;

    const onKeyUpUpdateState = (e: any) => {        
        const parameters: any = e;

        if (fieldProps?.isDirty && fieldProps?.fieldValue)
            fieldProps.isDirty.current = true;

        if(fieldProps?.handleOnChange){
            fieldProps.handleOnChange(parameters);
        }
    }

    useEffect(() => {
        setEditorLoaded(true);
    }, []);

    const renderTextAreaFieldUI = () => {
        let _ClassicEditor: any = ClassicEditor;
        let config: any = {
            licenseKey: 'GPL',
            toolbar: [ 'undo', 'redo', 'heading', 'bold', 'italic', 'blockQuote', 'link', 'insertTable', 'bulletedList', 'numberedList']
        };

        return <CKEditor
            editor={_ClassicEditor}
            data={fieldProps?.fieldValue ?? ""}
            config={config}
            disabled={fieldProps.disabled}
            onChange={(event: any, editor: any) => {
                onKeyUpUpdateState(editor.getData());
            }}
        />
    }

    return <StyledFormRichTextEditorfield $isError={errorMsg != null && errorMsg != ""} $darkMode={isDarkMode} $disabled={fieldProps?.disabled ?? false} className={"richTextFieldContainer " + (fieldProps?.fieldClassName != null && fieldProps?.fieldClassName != "" ? fieldProps.fieldClassName : "")}>
        {/* ---------TITLE---------- */}
        {!fieldProps.hideLabel && <CustomFormTitle title={fieldProps.title}
            required={fieldProps.required}
            hideLabel={fieldProps.hideLabel}
            exclamationHoverItemDisplayText={fieldProps.exclamationHoverItemDisplayText} />}

        {/* ---------SIDE CONTENT---------- */}
        <div className="labelSideContentContainer">{fieldProps.labelSideContent}</div>

        {/* ---------RICHTEXT---------- */}
        {editorLoaded && renderTextAreaFieldUI()}
        {errorMsg != null && errorMsg != "" && <Typography className="richTextErrorMessage">{errorMsg}</Typography>}
    </StyledFormRichTextEditorfield>
}

export default FormRichTextField;